/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
  search: {
    width: 32,
    height: 32,
    viewBox: '0 0 24 24',
    data: '<circle pid="0" cx="11" cy="11" r="8"/><path pid="1" d="M21 21l-4.35-4.35"/>',
  },
});
